import { PropsWithChildren } from 'react';

export function ScreenshotPrevention({ children }: PropsWithChildren) {
  return children;
}
